<template>
<div class="add-user">
    <div class="main-content-90">
        <div class="form">
            <el-form :model="addUserForm" status-icon :rules="addUserRule" ref="addUserForm" label-width="100px" class="demo-ruleForm">
                <div class="added-user-formTitle">添加用户</div>
                <div class="added-user-formContent">
                    <el-form-item label="车主姓名" prop="carUserName">
                        <el-input type="text" placeholder="请输入车主姓名" v-model="addUserForm.carUserName" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="车主手机号" prop="carUserTel">
                        <el-input type="text" placeholder="请输入车主手机号" v-model="addUserForm.carUserTel" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="车主车牌号" prop="carNum">
                        <el-input type="text" v-model="addUserForm.carNum" placeholder="请输入车主车牌号"></el-input>
                    </el-form-item>
                    <el-form-item label="车的类型" prop="carType">
                        <el-input type="text" v-model="addUserForm.carType" placeholder="请输入车的类型"></el-input>
                    </el-form-item>
                    <el-form-item label="保养次数" prop="fixNum">
                        <el-input type="text" v-model="addUserForm.fixNum" placeholder="请输入保养次数"></el-input>
                    </el-form-item>
                </div>
                <el-form-item class="added-user-submit">
                    <el-button type="primary" @click="saveUserInfo">保存</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapGetters,
    mapMutations
} from 'vuex'
export default {
    data() {
        var checkCarUserName = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('车主姓名不能为空'));
            }
            setTimeout(() => {
                callback();
            }, 1000);
        };
        var checkCarUserTel = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('车主手机号不能为空'));
            }
            setTimeout(() => {
                callback();
            }, 1000);
        };
        var checkCarNum = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('车主车牌号不能为空'));
            }
            setTimeout(() => {
                callback();
            }, 1000);
        };
        var checkCarType = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('车的类型不能为空'));
            }
            setTimeout(() => {
                callback();
            }, 1000);
        };
        var checkFixNum = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('保养次数不能为空'));
            }
            setTimeout(() => {
                callback();
            }, 1000);
        };
        return {
            addUserForm: {
                carUserName: '',
                carUserTel: '',
                carNum: '',
                carType: '',
                fixNum: ''
            },
            addUserRule: {
                carUserName: [{
                    validator: checkCarUserName,
                    trigger: 'blur'
                }],
                carUserTel: [{
                    validator: checkCarUserTel,
                    trigger: 'blur'
                }],
                carNum: [{
                    validator: checkCarNum,
                    trigger: 'blur'
                }],
                carType: [{
                    validator: checkCarType,
                    trigger: 'blur'
                }],
                fixNum: [{
                    validator: checkFixNum,
                    trigger: 'blur'
                }]
            }
        };
    },
    computed: {
        ...mapGetters(['user', 'userTypeNum'])
    },
    methods: {
        saveUserInfo () {
            // 1. 判断参数是否正确
            // 2. 提交参数
            let params = {
                name: this.addUserForm.carUserName,
                phone: this.addUserForm.carUserTel,
                car_number: this.addUserForm.carNum,
                car_type: this.addUserForm.carType,
                em_number: this.addUserForm.fixNum
            }
            this.axios.post('customer_list', JSON.stringify(params))
            .then(res => {
                this.$message({
                    message: res.data.msg,
                    type: 'success'
                })
            })
        }
    }
}
</script>

<style scoped>
@import url(../../assets/css/base.css);

.add-user {
    background-color: #F9F9F9;
    height: 1000px;
}

.form {
    position: absolute;
    top: 200px;
    left: 50%;
    transform: translate(-50%);
    width: 615px;
    height: 359px;
}

.added-user-formTitle {
    width: 615px;
    height: 113px;
    background-color: #00b662;
    font-size: 22px;
    line-height: 113px;
    text-align: center;
    color: #fff;
    font-family: PingFangSC-Medium, Microsoft YaHei;
    border-radius: 6px 6px 0 0;
}

.added-user-formContent {
    padding: 27px 163px;
    background-color: #fff;
    border-radius: 0 0 7px 7px;
    padding-bottom: 40px;
}

.el-form-item {
    margin-bottom: 22px;
}

.added-user-submit {
    position: relative;
}

.added-user-submit .el-button {
    position: absolute;
    top: 40px;
    left: 50%;
    width: 100px;
    height: 40px;
    border-radius: 22.5px;
    background: #00ae66;
    border: none;
    transform: translate(-50%, 0);
}
</style>



// WEBPACK FOOTER //
// src/pages/userManage/AddUser.vue